import Vue from 'vue';
import Router from 'vue-router';
import Calendar from './views/Calendar.vue';
import LogIn from './views/LogIn.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Log In',
      component: LogIn,
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
    },
    {
      path: '/requests',
      name: 'Requests',
      component: () => import(/* webpackChunkName: "requests" */ './views/Requests.vue'),
    },
    {
      path: '/admin/users',
      name: 'Users',
      component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
    },
    {
      path: '/admin/leave-types',
      name: 'Leave Types',
      component: () => import(/* webpackChunkName: "users" */ './views/LeaveTypes.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Log In') {
    next();
  } else {
    if (localStorage.getItem('token')) {
      next();
    } else {
      next('/');
    }
  }
});

export default router;
